import { useGetProgressTrackingConfigurationQuery } from 'store/api/tenants';
import { FinalizedHoursDto } from 'types/dashboard';
import { ProgressTrackingHoursMetric } from 'types/tenants';

export type ProgressMetric = {
    /** The finalised-hours field compared against the targets. */
    field: keyof FinalizedHoursDto;
    /** The hours line's label, and the lowercase phrase the annual target field is suffixed with. */
    labelId: string;
    phraseId: string;
    tooltipId: string;
};

const METRICS: Record<ProgressTrackingHoursMetric, ProgressMetric> = {
    CLIENT_HOURS: {
        field: 'clientHours',
        labelId: 'dashboard.progress-tracking.metric.client-hours',
        phraseId: 'dashboard.progress-tracking.metric.client-hours-phrase',
        tooltipId: 'dashboard.progress-tracking.metric.client-hours-tooltip',
    },
};

/**
 * The tenant's progress-tracking metric, which every signed-in user may read. Loading, failed or unknown reads as
 * the default metric, so the labels never flicker.
 */
export const useProgressMetric = ({ skip = false }: { skip?: boolean } = {}): ProgressMetric => {
    const { data } = useGetProgressTrackingConfigurationQuery(undefined, { skip });
    return METRICS[data?.hoursMetric ?? 'CLIENT_HOURS'] ?? METRICS.CLIENT_HOURS;
};
